import {
  SpecialtyOptionViewModel,
  ProviderOptionViewModel,
  TypeaheadGroupedOptionViewModel,
} from '@provider-directory/types/search.model';
import {
  TypeAheadRequest,
  TypeaheadCategories,
} from '@provider-directory/types/typeahead.contracts';

export const getTypeaheadSearchParams = (
  request: TypeAheadRequest,
): URLSearchParams => {
  const params = new URLSearchParams();
  params.append('terms', request.terms);
  params.append(
    'categories',
    (request.categories?.length
      ? request.categories
      : TypeaheadCategories.options
    ).join(','),
  );
  return params;
};

export const getTypeaheadSearchPath = (customer: string): string =>
  `/v1/${customer}/typeahead`;

export const getTypeaheadSearchV2Path = (customer: string): string =>
  `/v2/${customer}/typeahead`;

export const getTypeaheadSearchV3Path = (): string => `/v3/typeahead`;

export const findSpecialties = async (
  filterText: string,
  signal: AbortSignal,
): Promise<SpecialtyOptionViewModel[]> => {
  const res = await fetch(
    `/pds-api/typeahead?${getTypeaheadSearchParams({
      terms: filterText,
      categories: ['specialties'],
    }).toString()}`,
    { signal },
  );

  const json = (await res.json()) as TypeaheadGroupedOptionViewModel;
  return json.specialties?.results ?? [];
};

export const findProviders = async (
  filterText: string,
  signal: AbortSignal,
): Promise<ProviderOptionViewModel[]> => {
  const res = await fetch(
    `/pds-api/typeahead?${getTypeaheadSearchParams({
      terms: filterText,
      categories: ['providerNames'],
    }).toString()}`,
    { signal },
  );
  const json = (await res.json()) as TypeaheadGroupedOptionViewModel;
  return json.providerNames?.results ?? [];
};
